import React from 'react';
import { useLocation, navigate } from '@reach/router';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import HeightIcon from '@material-ui/icons/Height';
import BatteryChargingFullIcon from '@material-ui/icons/BatteryChargingFull';

import FooterStyles from './Footer.styles';

const Footer: React.FC = () => {
  // Router
  const location = useLocation();

  // Render
  return (
    <FooterStyles>
      <BottomNavigation
        onChange={(_event, value) => navigate(value)}
        value={location.pathname}
        showLabels
      >
        <BottomNavigationAction label="Photos" value="/photos" icon={<CameraAltIcon />} />
        <BottomNavigationAction label="Size" value="/size" icon={<HeightIcon />} />
        <BottomNavigationAction label="Battery" value="/battery" icon={<BatteryChargingFullIcon />} />
      </BottomNavigation>

      <footer>
        <div className="copywrite">&copy; {new Date().getFullYear()} Telefónica UK Limited.</div>
      </footer>
    </FooterStyles>
  );
};

export default Footer;
